import { createRoot } from "react-dom/client";
import React, { Suspense } from "react";

import App from "./app";
import Providers from "providers";

import "helpers/localize";

// styles
import "devextreme/dist/css/dx.material.blue.light.compact.css";
import "assets/styles/devextremThem/dxmaterialcustom.css";
import "react-toastify/dist/ReactToastify.css";
import "react-image-gallery/styles/css/image-gallery.css";
import "assets/styles/main.scss";
declare global {
  /***
   * Testing function works exactly as `console.log(...)` in development mode only `process.env.NODE_ENV === "development"`.
   * @param args:any
   * @returns:void
   */
  function checkout(chargeObject: any, onSuccess?: (data: any) => void, onFailure?: (data: any) => void): () => void;
} // the declaration of

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Suspense fallback={<div className="loader" />}>
    <Providers>
      <App />
    </Providers>
  </Suspense>
);
